const Metadata = (params) => {
  const normalizedData = {
    metaTitle: null,
    metaDescription: null,
    keywords: null,
    metaRobots: null,
    structuredData: null,
    metaViewport: null,
    canonicalURL: null,
    metaImage: null,
    metaSocial: [],
    ...params
  }

  return {
    title: normalizedData.metaTitle,
    description: normalizedData.metaDescription,
    keywords: normalizedData.keywords,
    openGraph: {
      title: normalizedData.metaTitle,
      description: normalizedData.metaDescription,
      url: normalizedData.canonicalURL,
      images: normalizedData.metaImage
    },
    robots: {
      index: normalizedData.noIndex === false ? 'index' : 'noindex',
      follow: normalizedData.noFollow === false ? 'follow' : 'nofollow'
    }
  }
}

export default Metadata
